module.exports = __webpack_public_path__ + "img/readyTyre.0a3f4a82.svg";